import htmlimg from "../assets/images/html-5.png"
import cssimg from "../assets/images/css-3.png"
import gitimg from "../assets/images/git.png"
import githubimg from "../assets/images/github.png"
import reactimg from "../assets/images/react.png"
import javascriptimg from "../assets/images/javascript.png"
import nodejsimg from "../assets/images/nodejs.png"
import  typescriptimg from "../assets/images/typescript.png"
import  sassimg from "../assets/images/sass.png"
import  bootstrapimg from "../assets/images/bootstrap.png"
import  mongoimg from "../assets/images/mongo.png"
import  muiimg from "../assets/images/mui.png"
import tailwindimg from "../assets/images/tailwind.png"
import firebaseimg from "../assets/images/firebase.png"
import reduximg from "../assets/images/redux.png"
import nextIcon from "../assets/images/nextjs-icon.svg"

export const skillcarddata = [
    {
        key: 1, 
        cardImage: htmlimg,
        title: "Html"
    },
    {
        key: 2, 
        cardImage: cssimg,
        title: "Css"
    },
    {
        key: 3, 
        cardImage: sassimg,
        title: "Sass"
    },
    {
        key: 4, 
        cardImage: bootstrapimg,
        title: "Bootstrap"
    },
    {
        key: 5, 
        cardImage: muiimg,
        title: "MUI"
    },
    {
        key: 6, 
        cardImage: javascriptimg,
        title: "Javascript"
    },
    {
        key: 7, 
        cardImage: reactimg,
        title: "ReactJS"
    },
    {
        key: 8, 
        cardImage: nodejsimg,
        title: "NodeJS"
    },
    {
        key: 9, 
        cardImage: typescriptimg,
        title: "Typescript"
    },
    {
        key: 10, 
        cardImage: githubimg,
        title: "Github"
    },
    {
        key: 11, 
        cardImage: gitimg,
        title: "Git"
    },
    {
        key: 12, 
        cardImage: mongoimg,
        title: "MongoDB"
    },
    {
        key: 13, 
        cardImage: reduximg,
        title: "Redux"
    },
    {
        key: 14, 
        cardImage: firebaseimg,
        title: "Firebase"
    },
    {
        key: 15,
        cardImage: tailwindimg,
        title: "Tailwind CSS"
    },
    {
        key: 16, 
        cardImage: nextIcon,
        title: "NextJs"
    },
]